const KpiCard = ({ label, value, hint, icon, accent = 'default' }) => (
  <div className={`kpi-card kpi-card--${accent}`}>
    <div className="kpi-card__icon" aria-hidden="true">
      <i className={`fas ${icon}`} />
    </div>
    <div className="kpi-card__body">
      <div className="kpi-card__label">{label}</div>
      <div className="kpi-card__value mono tabular-nums">{value}</div>
      {hint && <div className="kpi-card__hint">{hint}</div>}
    </div>
  </div>
);

export default KpiCard;
